import { useState } from 'react';

import './styles/save-conflict.css';

// WHAT A 409 IS FOR, AND WHY IT MUST NOT CLOSE THE FORM.
//
// Every content write in the breakdown surface carries the revision that was
// read. When somebody else wrote first, the backend refuses with `gate:
// revision` instead of letting the second save flatten the first. That refusal
// is a feature, and the only way to waste it is to react badly to it:
//
//   - Reloading the row on top of the editor throws away what the person just
//     typed, which is the loss the mechanism was built to prevent, arriving by
//     a different door.
//   - Refetching the revision and resending silently is worse still: it turns
//     the guard off and completes the overwrite the backend just stopped.
//
// So the draft stays on screen, untouched, and a person decides. The only two
// honest moves are "keep mine and merge by hand" and "throw mine away and take
// theirs", and both are offered by name.

export default function SaveConflict({ fields = [], onReload, onDismiss }) {
    const [showing, setShowing] = useState(false);
    const differing = fields.filter(field => field.mine !== field.theirs);

    return (
        <div className="save-conflict" role="alert">
            <div className="save-conflict__head">
                <h3 className="save-conflict__title">Este contenido cambió mientras lo editabas</h3>
                <p className="save-conflict__text">
                    Otra sesión guardó antes que vos. <strong>No se perdió nada de lo que
                    escribiste</strong>: sigue acá abajo, sin guardar. Compará antes de decidir.
                </p>
            </div>

            {differing.length > 0 && (
                <>
                    <button
                        type="button"
                        className="save-conflict__toggle"
                        onClick={() => setShowing(value => !value)}
                        aria-expanded={showing}
                    >
                        {showing ? 'Ocultar la comparación' : `Comparar ${differing.length} campo${differing.length === 1 ? '' : 's'}`}
                    </button>

                    {showing && (
                        <dl className="save-conflict__diff">
                            {differing.map(field => (
                                <div key={field.name} className="save-conflict__row">
                                    <dt className="save-conflict__field">{field.label}</dt>
                                    <dd className="save-conflict__side">
                                        <span className="save-conflict__side-label">Lo tuyo</span>
                                        <pre className="save-conflict__value">{field.mine || '—'}</pre>
                                    </dd>
                                    <dd className="save-conflict__side">
                                        <span className="save-conflict__side-label">Lo guardado</span>
                                        <pre className="save-conflict__value">{field.theirs || '—'}</pre>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    )}
                </>
            )}

            <div className="save-conflict__actions">
                {/* Destructive, and labelled as what it does. "Recargar" alone
                    reads like a refresh and this one drops the draft. */}
                <button type="button" className="save-conflict__discard" onClick={onReload}>
                    Descartar mis cambios y traer lo guardado
                </button>
                <button type="button" className="save-conflict__keep" onClick={onDismiss}>
                    Seguir con lo mío
                </button>
            </div>
        </div>
    );
}
